<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn" [class.btn-second]="true" (click)="doGetPreFilter()">
        取前次
      </button>
    </mat-toolbar>
    <div class="jk-grid-cols-2">
      <app-jkcombobox #kindCom class="jk-combobox-border" [styleDisplay]="'flex'" label="種類" [(value)]="filterOpt.kind" [items]="kindList" >
      </app-jkcombobox>
      <app-jkdaterange #dateCom label="日期範圍" [(valueA)]="filterOpt.dateA" [(valueB)]="filterOpt.dateB"
      [showClearButton]="true" >
      </app-jkdaterange>
      <app-jkcombobox #accountCom class="jk-combobox-border" [styleDisplay]="'flex'" label="帳號" [(value)]="filterOpt.account" [items]="accountList">
      </app-jkcombobox>


    </div>
</mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="doComfirm()">
        <mat-icon fontIcon="check_circle"></mat-icon>過帳
      </button>
    </mat-toolbar>
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)"></app-jkgridwin>
  </mat-tab>

</mat-tab-group>

